/**
 * run mode and environment
 * @type {boolean}
 * @private
 */
export const __prod__ = process.env.NODE_ENV === 'production'
export const __dev__ = process.env.NODE_ENV === 'development'
export const __storybook__ = process.env.NODE_ENV === 'storybook'
export const __local_cdn__ = process.env.REACT_APP_CDN_MODE === 'true'
export const __localhost__ = window.location.host.includes('localhost')
export const __aok_test_system__ = window.location.href.includes(
  'pcmaokdet3-test003.test.colt1.aok.de'
)

// cache reset on close (and next open) tab
export const __initial_reset_cache__ =
  process.env.REACT_APP_RESET_CACHE_ON_INITIAL_LOAD === 'true'

/**
 * debug && error tracing tools
 * @type {boolean}
 * @private
 */
export const __loadApp__ =
  null !== document.getElementById('appReactNavigatoren') // check if client was append to dom
export const __show_debug_output__ =
  process.env.REACT_APP_SHOW_DEBUG_OUTPUT === 'true'
export const __check_injected_params__ =
  localStorage.getItem('check-plugin') === 'true' || false // check plugin properties
// allow test and productive system
// export const __enable_sentry__ = __prod__ && !__local_cdn__ // sentry integration
// export const __show_axe__ = process.env.REACT_APP_SHOW_AXE === 'true'

// geo regex
export const LATITUDE_PATTERN = /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/
export const LONGITUDE_PATTERN =
  /^(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/

/**
 * base config
 * @type {number}
 */
export const API_TIMEOUT = 0
export const DEV_API_URL = `${ window.location.protocol }//${ window.location.hostname }:8080/api/v1/` // do not remove the port, otherwise we will get CORS errors
export const DEV_API_URL_NO_VARNISCH = `${ window.location.protocol }//${ window.location.hostname }/api/v1/` // do not remove the port, otherwise we will get CORS errors
// export const DEV_API_URL = 'https://navigatoren-api-stack01-test.aok.de/api/v1'

// Google Maps API Keys
export const GOOGLE_API_KEY =
  window.NAVIGATOREN_GOOGLE_API_KEY || 'AIzaSyBzYhtl5Eu4sX8yALaJCbxIMZNVLhA81nY'

// indicates navigator type
export const NAVI_TYPES = ['HEALTH', 'CARE']

/**
 * define allowed search params for every result tile
 * @type {{hospitals: string[], dayandnightcare: string[], caresearch: string[], carehomes: string[], doctors: string[], cross: string[], caresupport: string[], oncallservices: string[], midwives: string[], careservices: string[], ambulances: string[]}}
 */
export const RESULT_TYPE_SEARCH_PARAMS = {
  doctors: ['query', 'location', 'radius', 'key', 'type'],
  hospitals: ['query', 'location', 'radius', 'key', 'type'],
  midwives: ['query', 'location', 'radius', 'key', 'type'],
  ambulances: ['query', 'location', 'radius'],
  cross: ['query', 'location', 'radius', 'key', 'type'],
  oncallservices: ['query', 'location', 'radius'],
  careservices: ['query', 'location', 'radius'],
  carehomes: ['query', 'location', 'radius'],
  caresearch: ['query', 'location', 'radius'],
  dayandnightcare: ['query', 'location', 'radius'],
  caresupport: ['query', 'location', 'radius'],
}

/**
 * value for redux state
 * @type {{AMBULANCES: string, CROSS: string, HOSPITALS: string, DAYANDNIGHTCARE: string, DOCTORS: string, MIDWIVES: string, ONCALLSERVICES: string, CARESERVICES: string, CAREHOMES: string, CARESEARCH: string, CARESUPPORT: string}}
 */
export const entryPointId = {
  DOCTORS: 'doctors',
  HOSPITALS: 'hospitals',
  MIDWIVES: 'midwives',
  AMBULANCES: 'ambulances',
  CROSS: 'cross',
  ONCALLSERVICES: 'oncallservices',
  CARESERVICES: 'careservices',
  CAREHOMES: 'carehomes',
  CARESEARCH: 'caresearch',
  DAYANDNIGHTCARE: 'dayandnightcare',
  CARESUPPORT: 'caresupport',
}

export const searchTypeIds = {
  DOCTORS: 'Arztsuche',
  HOSPITALS: 'Krankenhaussuche',
  MIDWIVES: 'Hebammensuche',
  AMBULANCES: 'Notfallambulanzen',
  CROSS: 'Querschnittsuche',
  ONCALLSERVICES: 'Bereitschaftsdienste',
  CARESERVICES: 'Pflegedienst',
  CAREHOMES: 'Pflegeheim',
  CARESEARCH: 'Pflegenavigator',
  DAYANDNIGHTCARE: 'TagesUndNachtpflege',
  CARESUPPORT: 'UnterstuetzungimAlltag',
}

// TODO @a.s check if we need this (looks like duplicated stuff)
/**
 * api end points for xhr requests
 * @type {{autoComplete: string, locationApiUrl: string, detailsHospital: string, bookmarks: string, dayAndNightCare: string, compare: string, detailsDoctor: string, locations: string, detailsCarehomes: string, detailsCareServices: string, caresupport: string}}
 */
export const apiEndpoints = {
  autoComplete: 'autocomplete/',
  locationApiUrl: 'location/resolve/',
  detailsHospital: 'hospital/',
  detailsDoctor: 'doctor/',
  locations: 'locations/',
  bookmarks: 'bookmarks/',
  compare: 'compare/',
  detailsCarehomes: 'carehome/',
  detailsCareServices: 'careservices/',
  dayAndNightCare: 'dayandnightcare/',
  caresupport: 'caresupport/',
  hospiceservices: 'hospiceservice/',
}

/**
 * minimum string length for autocomplete request
 * @type {{hospitals: {query: number, location: number}, doctors: {query: number, location: number}, cross: {query: number, location: number}, oncallservices: {query: number, location: number}, midwives: {query: number, location: number}, ambulances: {query: number, location: number}}}
 */
export const AUTOCOMPLETE_MIN_STRING_FOR_XHR = {
  hospitals: { query: 3, location: 3 },
  doctors: { query: 3, location: 3 },
  cross: { query: 3, location: 3 },
  midwives: { query: 3, location: 3 },
  ambulances: { query: 3, location: 3 },
  oncallservices: { query: 3, location: 3 },
  careservices: { query: 3, location: 3 },
  carehomes: { query: 3, location: 3 },
  caresearch: { query: 3, location: 3 },
  dayandnightcare: { query: 3, location: 3 },
  caresupport: { query: 3, location: 3 },
}

/**
 * default value for radius select component
 * @type {{hospitals: number, doctors: number, cross: number, oncallservices: number, midwives: number, ambulances: number}}
 */
export const DEFAULT_RADIUS = {
  hospitals: 50000,
  doctors: 10000,
  midwives: 10000,
  ambulances: 10000,
  cross: 10000,
  oncallservices: 10000,
  careservices: 10000,
  carehomes: 10000,
  caresearch: 10000,
  dayandnightcare: 10000,
  caresupport: 10000,
}

/**
 * mapping for merging of clusters
 */
export const mappedClusters = {
  meta_doctor_specialisation: 'doctor_specialisation',
}

/**
 * mapped cluster titles for auto complete cluster
 * @type {{doctor_specialisation: string, ambulance_type: string, midwife_service: string, ops_check: string, ambulance_level: string, icd: string, doctor: string, doctor_qualification: string, hospital_department_name: string, ops_treatment: string, on_call_service_type: string, on_call_service_name: string, ambulance_name: string, doctor_service: string, doctor_accident_insurance: string, midwife_name: string, hospital_name: string}}
 */
export const mappedClusterTitles = {
  /* hospitals */
  icd: 'Krankheiten',
  ops_check: 'Untersuchungen',
  ops_treatment: 'Behandlungen',
  hospital_department_name: 'Fachabteilungen',
  hospital_name: 'Krankenhäuser',
  /* doctors */
  doctor: 'Einrichtungs-/Arztnamen',
  doctor_service: 'Leistungen',
  doctor_specialisation: 'Facharztgebiete',
  doctor_qualification: 'Qualifikation',
  doctor_accident_insurance: 'Durchgangsärzte',
  /* ambulances */
  ambulance_type: 'Ambulanzart',
  ambulance_level: 'Notfallstufe',
  ambulance_name: 'Name',
  /* midwives */
  midwife_name: 'Name',
  midwife_service: 'Hebammenleistungen',
  /* ambulances */
  on_call_service_name: 'Name',
  on_call_service_type: 'Art des Bereitschaftsdiensts',
  /* carehomes */
  nursing_home_name: 'Pflegeheime',
  /* careservices */
  care_service_name: 'Pflegedienste',
  /* careservices */
  day_night_care_name: 'Tages und Nachtpflegen',
  /* caresupport */
  care_support_name: 'Allgemeine Unterstützung',
}

/**
 * for use in compare view
 * @type {{HIGH: string, MEDIUM: string, LOW: string}}
 */
export const mappedTreatmentScores = {
  HIGH: 'hoch',
  MEDIUM: 'mittel',
  LOW: 'niedrig',
}

/**
 * for use in loader component
 * @type {{hospitals: string, doctors: string, cross: string, asv_teams: string, oncallservices: string, midwives: string, ambulances: string}}
 */
export const mappedEntryPointNames = {
  hospitals: 'Krankenhäuser',
  doctors: 'Ärzte',
  midwives: 'Hebammen',
  ambulances: 'Ambulanzen',
  cross: 'Ergebnisse',
  oncallservices: 'Bereitschaftsdienste',
  asv_teams: 'ASV Teams',
  careservices: 'Pflegedienste',
  carehomes: 'Pflegeheime',
  caresearch: 'Pflegenavigator',
  dayandnightcare: 'Tages- und Nachtpflegen',
  caresupport: 'Unterstützungen im Alltag',
  hospiceservices: 'Hospizdienste',
}

/**
 * for use in loader component
 * @type {{hospitals: string, doctors: string, cross: string, asv_teams: string, oncallservices: string, midwives: string, ambulances: string}}
 */
export const mappedEntryPointNamesQSS = {
  ...mappedEntryPointNames,
  ambulances: 'Ambulante Behandlungsmöglichkeiten',
}

/**
 * map entry points to route names
 * used for detail urls
 * currently only hospital and doctors have detail pages
 * @type {{hospitals: string, carehomes: string, doctors: string, careservices: string}}
 */
export const mappedEntryPointRoutes = {
  hospitals: '/krankenhaus',
  doctors: '/arzt',
  careservices: '/pflegedienst',
  carehomes: '/pflegeheim',
  dayandnightcare: '/tagesNachtpflege',
  caresupport: '/unterstützungImAlltag',
  hospiceservices: '/hospizdienst',
}

/**
 * * possible Values for pageType Prop (injected by the typo Plg.)
 * @type {{RESULT_PAGE: string, START_PAGE: string, SEO_PAGE: string}}
 */
export const PAGE_TYPES = {
  START_PAGE: 'startPage',
  SEO_PAGE: 'seoPage',
  RESULT_PAGE: 'resultPage',
}

/**
 * order for sorts array (result pages)
 * @type {string[]}
 */
export const ORDER_RESULT_SORTING = [
  'own_share_calc',
  'best_result',
  'alphabetical',
  'descending',
  'distance',
  'qsr_',
  'iqtig',
  'recommendations',
  'treatment_count',
  'care_level_1',
  'care_level_25',
  'care_report_2017_score',
]

/**
 * for use at main container to control qsr single indicators rendering
 * */
export const SHOW_SINGLE_QSR_INDICATORS = [
  'N40',
  'C61',
  '5-601',
  '5-603',
  '5-604',
  '8-837',
  '8-83d',
  'I35',
  '5-35a.05',
]

/**
 * cluster id for automatic address selection
 * @type {string[]}
 */
export const AUTOCOMPLETE_SELECT_WITH_ADDRESS_INDEX = [
  'doctor-and-office-names',
  'autocomplete-ambulance-name',
  'autocomplete-on-call-service-name',
  'nursing_home_name',
  'day_night_care_name',
  'care_service_name',
]

/**
 * define the limit for match rendering at cluster component
 * @type {number}
 */
export const MAX_NUMBER_OF_QUERY_MATCHES = 5

/**
 *  for use at search actions
 * @type {{is_aop: boolean, generalTooltips: {}, is_treatment_reason: boolean, show_details: boolean, count: number, filters: *[], type: string, aokServices: *[], size: number, active_sorting: null, sorting: *[], location: *[], from: number, generalHints: *[], results: *[], key: string}}
 */
export const EMPTY_SEARCH_DATA = {
  results: [],
  location: [],
  generalTooltips: {},
  generalHints: [],
  count: 0,
  type: '',
  key: '',
  from: 0,
  size: 10,
  is_treatment_reason: false,
  is_aop: false,
  filters: [],
  sorting: [],
  active_sorting: null,
  show_details: false,
  aokServices: [],
}

/**
 * defines all bookable elements
 * => bookable elements has also a detail page [next const]
 * => bookable elements also con compared
 * can also used for result types which have a detail view
 * @type {(string)[]}
 */
export const BOOKABLE_TYPES = [
  // health
  entryPointId.DOCTORS,
  entryPointId.HOSPITALS,
  // care
  entryPointId.CAREHOMES,
  entryPointId.CARESERVICES,
  entryPointId.DAYANDNIGHTCARE,
  // entryPointId.CARESUPPORT,
]

/**
 * bookable elements has a detail page
 * @type {(string)[]}
 */
export const RESULT_HAS_DETAIL_PROFILE = [...BOOKABLE_TYPES]

/**
 * used for additional select in searchbar
 * typ => is used for the get param as name
 * @type {{dayandnightcare: [{options: [{label: string, value: string}, {label: string, value: string}, {label: string, value: string}], typ: string, label: string, preSelect: string}, {options: [{label: string, value: string}, {label: string, value: string}, {label: string, value: string}], typ: string, label: string}, {options: [{label: string, value: string}, {label: string, value: string}, {label: string, value: string}, {label: string, value: string}], typ: string, label: string}], carehomes: [{options: [{label: string, value: string}, {label: string, value: string}, {label: string, value: string}, {label: string, value: string}, {label: string, value: string}, null, null, null, null, null, null, null], typ: string, label: string, preSelect: string}, {options: [{label: string, value: string}, {label: string, value: string}, {label: string, value: string}, {label: string, value: string}], typ: string, label: string, preSelect: string}], careservices: [{tooltip: {tip: string, title: string}, options: [{label: string, value: string}, {label: string, value: string}, {label: string, value: string}], typ: string, label: string}]}}
 */
export const ADDITIONAL_SEARCHBAR_SELECTS = {
  carehomes: [
    {
      typ: 'carehomes_focus',
      label: 'Pflegefachlicher Schwerpunkt',
      preSelect: '000',
      options: [
        { label: 'Kein besonderer Schwerpunkt', value: '000' },
        { label: 'verhaltensauffällige Demenzkranke', value: '001' },
        { label: 'Beatmung Erwachsener', value: '002' },
        { label: 'Wachkoma / Phase F', value: '003' },
        { label: 'psychische Erkrankungen', value: '004' },
        { label: 'Körperbehinderung', value: '005' },
        { label: 'geistige Behinderungen', value: '006' },
        { label: 'Beatmung Kinder / Jugendliche', value: '007' },
        { label: 'neurologische Erkrankungen', value: '008' },
        { label: 'Unterbringungsbeschluss', value: '009' },
        { label: 'Junge Erwachsene', value: '010' },
        { label: 'Obdachlose', value: '011' },
      ],
    },
    {
      typ: 'carehomes_care_typ',
      label: 'Art des Pflegeplatzes',
      preSelect: '001',
      options: [
        { label: 'Vollstationäre Pflege', value: '001' },
        { label: 'Kurzzeitpflege', value: '003' },
      ],
    },
  ],
  careservices: [
    {
      typ: 'PE_ANG_KRANKENPFLEGE',
      label: 'Art des Pflege- und Betreuungsdienstes',
      tooltip: {
        title: 'Art des Pflege- und Betreuungsdienstes',
        tip: 'Bitte geben Sie über den Filter an, ob Sie einen Dienst suchen, der eine medizinische Pflege (Krankenpflege/ Behandlungspflege) anbietet, ob Sie einen Dienst suchen, der grundpflegerische Leistungen (z.B. Körperpflege, Hauswirtschaft, Betreuungsmaßnahmen) oder  Betreuungsdienste suchen, die für Pflegebedürftige dauerhaft pflegerische Betreuungsmaßnahmen und Hilfen bei der Haushaltsführung erbringen, d.h. die ausschließlich hauswirtschaftliche Versorgung oder Betreuungsmaßnahmen anbieten.',
      },
      preSelect: '002',
      showCalc: ['002'], // use for display calculation button rendering
      options: [
        { label: 'Medizinische Pflege', value: '001' },
        {
          label:
            'Grundpflegerische Leistungen sowie Betreuung und hauswirtschaftliche Versorgung',
          value: '002',
        },
        {
          label:
            'Ausschließlich pflegerische Betreuungsmaßnahmen und Hilfen bei der Haushaltsführung für Pflegebedürftige',
          value: '003',
        },
      ],
    },
  ],
  dayandnightcare: [
    {
      typ: 'PR_TYP',
      label: 'Pflegefachlicher Schwerpunkt',
      preSelect: '000',
      options: [
        { label: 'Kein besonderer Schwerpunkt', value: '000' },
        { label: 'verhaltensauffällige Demenzkranke', value: '001' },
        { label: 'Beatmung Erwachsener', value: '002' },
        // { label: 'Wachkoma / Phase F', value: '003' },
        { label: 'psychische Erkrankungen', value: '004' },
        // { label: 'Körperbehinderung', value: '005' },
        // { label: 'geistige Behinderungen', value: '006' },
        // { label: 'Beatmung Kinder / Jugendliche', value: '007' },
        // { label: 'neurologische Erkrankungen', value: '008' },
        // { label: 'Unterbringungsbeschluss', value: '009' },
        // { label: 'Junge Erwachsene', value: '010' },
        // { label: 'Obdachlose', value: '011' },
      ],
    },
    {
      typ: 'PR_PFGRAD',
      label: 'Pflegegrad',
      preSelect: '1',
      options: [
        { label: 'Pflegegrad 1', value: '1' },
        { label: 'Pflegegrad 2', value: '2' },
        { label: 'Pflegegrad 3', value: '3' },
        { label: 'Pflegegrad 4', value: '4' },
        { label: 'Pflegegrad 5', value: '5' },
      ],
    },
    {
      typ: 'PR_PFDAYS',
      label: 'Anzahl Besuchstage pro Monat',
      preSelect: '1',
      options: [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '7', value: '7' },
        { label: '8', value: '8' },
        { label: '9', value: '9' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
      ],
    },
  ],
}

/**
 * use for location persists for distance calculation
 * @type {(string)[]}
 */
export const SET_LOCATION_DATA_FOR_SEARCH = [
  entryPointId.DAYANDNIGHTCARE,
  entryPointId.CARESUPPORT,
  entryPointId.CARESERVICES,
  entryPointId.CAREHOMES,
]

/**
 * mutually exclusive filters
 * condition: filters must be eather parent or in the same group
 * https://bugs.onedev.aok.de/browse/MGMNAVSUP-333
 */
export const MUTUALLY_EXCLUSIVE_FILTERS = {
  show_family_doctor: 'hide_family_doctor',
  hide_family_doctor: 'show_family_doctor',
}

/**
 * entryPoints where to append lat and lng
 * to the detail url for distance calc
 */
export const GOOGLE_DISTANCE_CALC = [
  // https://bugs.onedev.aok.de/browse/MGMNAVSUP-709
  // entryPointId.DAYANDNIGHTCARE,
  // entryPointId.CARESERVICES,
]

/**
 *  * flag for display exact distance to search location
 *   * @type {(string)[]}
 *    */
export const TILE_HAS_EXACT_DISTANCE = [entryPointId.CARESERVICES]
